import { useSelector, useDispatch } from 'react-redux'
import { myOpenOrdersSelector } from '../store/selectors'
import { cancelOrder } from '../store/interactions'
import sort from '../assets/sort.svg'
import Banner from './Banner'

const OrdersPage = ({ onClose }) => {
  const provider = useSelector(state => state.provider.connection)
  const exchange = useSelector(state => state.exchange.contract)
  const symbols = useSelector(state => state.tokens.symbols)
  const myOpenOrders = useSelector(myOpenOrdersSelector)
  const dispatch = useDispatch()

  const cancelHandler = (order) => {
    cancelOrder(provider, exchange, order, dispatch)
  }

  const cancelAllHandler = () => {
    if (myOpenOrders && myOpenOrders.length > 0) {
      myOpenOrders.forEach(order => {
        cancelOrder(provider, exchange, order, dispatch)
      })
    }
  }

  return (
    <div className="orders-page">
      <div className="orders-page__header">
        <h2>My Open Orders</h2>
        <div className="orders-page__actions">
          {myOpenOrders && myOpenOrders.length > 0 && (
            <button className="button--sm button--danger" onClick={cancelAllHandler}>
              Cancel All
            </button>
          )}
          <button className="button--sm" onClick={onClose}>
            Back to Trading
          </button>
        </div>
      </div>

      {!myOpenOrders || myOpenOrders.length === 0 ? (
        <Banner text='No Open Orders' />
      ) : (
        <table>
          <thead>
            <tr>
              <th>{symbols && symbols[0]}<img src={sort} alt="Sort" /></th>
              <th>{symbols && symbols[0]}/{symbols && symbols[1]}<img src={sort} alt="Sort" /></th>
              <th>Type</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {myOpenOrders.map((order, index) => (
              <tr key={index}>
                <td style={{ color: `${order.orderTypeClass}` }}>{order.token0Amount}</td>
                <td>{order.tokenPrice}</td>
                <td style={{ color: `${order.orderTypeClass}` }}>
                  {order.orderType === 'buy' ? 'Buy' : 'Sell'}
                </td>
                <td>
                  <button className='button--sm' onClick={() => cancelHandler(order)}>Cancel</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}

export default OrdersPage
